export default __webpack_public_path__ + "static/media/poster-05.593dea20.png";